import type en from '../en/profile'
import type { Translation } from '../types'

/** My profile: language, contact, password and the person’s own settings */
const profile: Translation<typeof en> = {
  "profile.language": "Idioma",
  "profile.languageHint": "El idioma del panel y de los mensajes que recibe. «Igual que la empresa» sigue el idioma de su empresa.",
  "profile.sameAsCompany": "Igual que la empresa",
  "profile.languageSaved": "Idioma guardado",
  "profile.languageNotSaved": "No se pudo guardar el idioma",
  "profile.pwChanged": "Contraseña cambiada",
  "profile.pwChangedText": "Se han cerrado todas las sesiones; este navegador ha vuelto a iniciar sesión.",
  "profile.pwFailed": "No se pudo cambiar la contraseña",
  "profile.pwCheck": "Compruebe su contraseña actual y vuelva a intentarlo.",
  "profile.vpnDownloaded": "Archivo VPN descargado",
  "profile.vpnDownloadedText": "Importe el archivo .ovpn en su cliente OpenVPN.",
  "profile.downloadFailed": "Error en la descarga",
  "profile.vpnNotYet": "El archivo VPN aún no está disponible.",
  "profile.title": "Mi perfil",
  "profile.alertContact": "Contacto para alertas",
  "profile.alertContactText": "Añada un número de teléfono en formato internacional para recibir avisos de caídas por WhatsApp o RCS.",
  "profile.appearance": "Apariencia",
  "profile.theme.light": "Claro",
  "profile.theme.dark": "Oscuro",
  "profile.default": "(predeterminado)",
  "profile.account": "Cuenta",
  "profile.companyAdmin": "Administrador de la empresa",
  "profile.teamMember": "Miembro del equipo",
  "profile.permissions": { one: "{count} permiso", other: "{count} permisos" },
  "profile.vpnAccess": "Acceso VPN",
  "profile.lastSeen": "Visto por última vez",
  "profile.downloadVpn": "Descargar el archivo .ovpn",
  "profile.vpnCreating": "Se está creando su cuenta VPN. Suele tardar unos minutos.",
  "profile.noVpn": "Todavía no hay cuenta VPN.",
  "profile.setup": "Instrucciones de configuración",
  "profile.changePw": "Cambiar contraseña",
  "profile.currentPw": "Contraseña actual",
  "profile.hidePw": "Ocultar contraseña",
  "profile.showPw": "Mostrar contraseña",
  "profile.newPw": "Nueva contraseña",
  "profile.confirmPw": "Confirmar contraseña",
  "profile.updatePw": "Actualizar contraseña",
  "profile.phoneSaved": "Número de teléfono guardado",
  "profile.phoneSaveFailed": "No se pudo guardar el número",
  "profile.codeSent": "Código enviado",
  "profile.codeSentRcs": "Consulte la aplicación de mensajes de ese teléfono (RCS).",
  "profile.codeSentWa": "Consulte WhatsApp en ese número.",
  "profile.codeFailed": "No se pudo enviar ningún código",
  "profile.phoneVerified": "Número de teléfono verificado",
  "profile.verifyFailed": "Error en la verificación",
  "profile.phone": "Número de teléfono",
  "profile.verified": "verificado",
  "profile.notVerified": "no verificado",
  "profile.save": "Guardar",
  "profile.sendAgain": "Volver a enviar",
  "profile.sendCode": "Enviar código de verificación",
  "profile.code": "Código de verificación",
  "profile.codePlaceholder": "Código de 6 dígitos",
  "profile.verify": "Verificar",
  "profile.verifiedOnly": "Los avisos por WhatsApp y RCS solo se envían a un número verificado.",
  "profile.phoneApp": "Aplicación móvil",
  "profile.phoneAppAddress": "En la aplicación Velanox, elija «Iniciar sesión en su propia empresa» y escanee este código, o escriba la dirección:",
  "profile.phoneAppSoon": "La aplicación llegará a App Store y Google Play.",
  "profile.phones": "Teléfonos que mantienen la sesión",
  "profile.noPhones": "Ningún teléfono mantiene la sesión.",
  "profile.thisPhone": "Este teléfono",
  "profile.phoneAdded": "añadido {when}",
  "profile.phoneUsed": "último uso {when}",
  "profile.removePhoneOf": "Quitar {name}",
  "profile.removePhoneConfirm": "¿Quitar {name}? Se cerrará la sesión y volverá a pedir la contraseña.",
  "profile.phoneRemoved": "Teléfono quitado",
  "profile.phoneRemoveFailed": "El teléfono no se ha quitado",
  "profile.push.on": "Push: activado",
  "profile.push.off": "Push: desactivado",
  "profile.push.allow": "Permitir notificaciones push en este teléfono",
  "profile.push.turnOff": "Desactivar las notificaciones push",
  "profile.push.denied": "Las notificaciones push están desactivadas en los ajustes de este teléfono",
  "profile.push.refused": "No se permitieron las notificaciones push en este teléfono",
  "profile.push.shortages": "Falta de material por notificación push",
  "profile.push.shortagesHint": "Solo sus teléfonos: el correo sobre la falta de material sigue igual.",
  "profile.push.notSaved": "No se pudo guardar el ajuste de push",
  "profile.push.channel": "Alertas",
}

export default profile
